import { useQuery } from "react-query";
import { getHeritageConnection } from "../api/getHeritageConnection";
import { IHeritageToken } from "../types/IHeritageConnection";
import { useCompanyFeature } from "hooks/useCompanyFeature";

/**
 * Gated on the company's heritage feature internally, so no caller can fire
 * this request for a company the feature is off for — the endpoint 404s there.
 */
export const useHeritageConnection = (options?: { enabled?: boolean }) => {
  const heritageEnabled = useCompanyFeature("heritage");
  return useQuery<IHeritageToken>(
    ["heritage-connection"],
    () => getHeritageConnection(),
    {
      enabled: heritageEnabled && options?.enabled !== false,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    }
  );
};
